"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItemViewConfig = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("../utils/prop-types"));

var _mimeType = _interopRequireDefault(require("../utils/mime-type"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable react/no-danger */
var ListItemViewConfig = {
  animationDelayOffset: 100,
  useAnimationDelayOffset: false
};
exports.ListItemViewConfig = ListItemViewConfig;

var ListItemView = function ListItemView(props) {
  var fileTypes = {
    "default": 'e866',
    pdf: 'e86a',
    img: 'e89c',
    video: 'e8a0',
    embed: 'e8a0',
    external: 'ea41'
  };

  var getFileType = function getFileType(mimeType) {
    var fileType = fileTypes["default"];
    if (mimeType === _mimeType["default"].PDF) fileType = fileTypes.pdf;else if (mimeType === _mimeType["default"].MP4) fileType = fileTypes.video;else if (mimeType === _mimeType["default"].JPEG || mimeType === _mimeType["default"].PNG || mimeType === _mimeType["default"].BMP) fileType = fileTypes.img;else if (mimeType === _mimeType["default"].EMBED) fileType = fileTypes.embed;else if (mimeType === _mimeType["default"].EXTERNAL) fileType = fileTypes.external;
    return fileType;
  };

  var item = props.item;
  var styles = {};

  if (ListItemViewConfig.useAnimationDelayOffset) {
    styles.animationDelay = props.index * ListItemViewConfig.animationDelayOffset;
  }

  return /*#__PURE__*/_react["default"].createElement("a", {
    className: "file-link ".concat(item.shouldDownload() && ' file-download-directly', " ").concat(item.locked && 'file-locked'),
    id: item.id,
    rel: "noopener noreferrer",
    target: "_blank",
    href: item.url,
    onClick: function onClick(e) {
      props.onItemClick.apply(null, [e, item]);
    },
    style: styles
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "content-type-icon",
    dangerouslySetInnerHTML: {
      __html: "&#x".concat(getFileType(item.mimeType), ";")
    }
  }), item.name);
};

ListItemView.propTypes = {
  onItemClick: _propTypes["default"].func.isRequired,
  item: _propTypes2["default"].item.isRequired,
  index: _propTypes["default"].number.isRequired
};
var _default = ListItemView;
exports["default"] = _default;